import React, { useEffect, useState } from 'react';
import api, { getDiagnosticToken, clearDiagnosticToken } from '@/utils/api';

/**
 * Persistent banner shown while a super-admin diagnostic view-as session is
 * active in this tab. Makes the mode unmistakable: whose dashboard this is,
 * that it is read-only, and whether message bodies are hidden.
 */
export default function DiagnosticBanner() {
  const [info, setInfo] = useState(null);
  const active = Boolean(getDiagnosticToken());

  useEffect(() => {
    if (!active) return;
    let cancelled = false;
    api.get('/api/auth/me')
      .then((res) => {
        if (!cancelled && res.data?.diagnostic) {
          setInfo({
            name: res.data.full_name,
            status: res.data.account_status,
            reveal: res.data.diagnostic.reveal_messages,
          });
        }
      })
      .catch((e) => {
        // Session expired or invalid — leave diagnostic mode quietly.
        if (e?.response?.status === 401) {
          clearDiagnosticToken();
          window.location.href = '/admin/users';
        }
      });
    return () => { cancelled = true; };
  }, [active]);

  if (!active) return null;

  const exit = async () => {
    try { await api.post('/api/auth/diagnostic-exit'); } catch { /* already expired */ }
    clearDiagnosticToken();
    window.location.href = '/admin/users';
  };

  return (
    <div className="fixed top-0 inset-x-0 z-[100] bg-amber-500 text-slate-900 text-sm font-medium px-4 py-2 flex items-center justify-center gap-3 flex-wrap shadow-md">
      <span>
        Diagnostic view{info?.name ? ` — ${info.name}` : ''}
        {info?.status && info.status !== 'active' ? ` (account ${info.status.replace('_', ' ')})` : ''}
        {' · read-only'}
        {info && !info.reveal ? ' · messages hidden' : ''}
      </span>
      <button
        onClick={exit}
        className="px-3 py-0.5 rounded-md bg-slate-900 text-amber-400 text-xs font-semibold hover:bg-slate-800 transition-colors"
      >
        Exit
      </button>
    </div>
  );
}
